import BlockContent from '@sanity/block-content-to-react'
import React from 'react'

import { SanityCta, SanityTabsCarouselTab } from '../../../graphql/gatsby'
import SanityLink, { NormalizedSanityLinkTagged } from '../../global/SanityLink'

export interface TabsCarouselActiveTabProps {
  activeTab: SanityTabsCarouselTab
  onCtaClick?: (
    cta: SanityCta,
    link: NormalizedSanityLinkTagged,
    tabTitle: SanityTabsCarouselTab['title'],
  ) => void
}

export const TabsCarouselActiveTab: React.FC<TabsCarouselActiveTabProps> = ({
  activeTab,
  onCtaClick,
}) => {
  const { content, highlight, label, primaryCta, secondaryCta, shortDescription, title } = activeTab
  return (
    <div className="flex flex-col gap-10 md:gap-8 md:flex-row mt-5 md:mt-10">
      <div className="flex flex-col flex-1">
        <h2 className="font-bold text-[32px] md:text-[40px] text-brand-navy mb-4 md:mb-5">
          {title}
        </h2>
        <p className="font-medium text-lg md:text-[20px] mb-3 text-brand-navy">
          {shortDescription}
        </p>
        <p className="text-xl md:text-xl font-bold text-brand-orange uppercase">{highlight}</p>
        <div className="flex flex-row gap-4 mt-6 md:mt-8 items-center">
          {primaryCta?.link && (
            <SanityLink
              className="bg-brand-orange text-xl font-bold text-white py-3 px-8 rounded-full"
              to={primaryCta.link}
              onClick={
                onCtaClick
                  ? (_e, normalized) => onCtaClick(primaryCta, normalized, title)
                  : undefined
              }
            >
              {primaryCta.title}
            </SanityLink>
          )}
          {secondaryCta?.link && (
            <SanityLink
              className="underline"
              to={secondaryCta.link}
              onClick={
                onCtaClick
                  ? (_e, normalized) => onCtaClick(secondaryCta, normalized, title)
                  : undefined
              }
            >
              {secondaryCta.title}
            </SanityLink>
          )}
        </div>
      </div>
      <div className="flex flex-col flex-1 xl:flex-[2]">
        <h3 className="font-bold uppercase text-text-primary text-sm mb-5">About this {label}</h3>
        <BlockContent blocks={content} />
      </div>
    </div>
  )
}
